import { createContext, useContext } from 'react';

import type { OverflowType } from './useOverflow';

export const OverflowContext = createContext<OverflowType | null>(null);
OverflowContext.displayName = 'OverflowContext';

export const useOverflowContext = () => {
    const context = useContext(OverflowContext);
    if (!context) {
        throw new Error('useOverflowContext must be used within a OverflowProvider');
    }
    return context;
};

export const OverflowProvider = OverflowContext.Provider;
